import {
  FALLBACK_LANGUAGES,
  canonicalizeLanguageTag,
} from "./supportedLanguages";

/**
 * Selector options fallback: the locales with bundled resources and curated
 * labels. Used while platform config v2 is unavailable or when its localization
 * block returns nothing usable. Not a filter on the payload — the backend owns
 * availability.
 */
export const FE_SUPPORTED_LANGUAGE_OPTIONS: string[] = [...FALLBACK_LANGUAGES];

type LanguageEntry = string | { code?: string; language?: string };

/**
 * Canonicalizes configured languages, preserving payload order and dropping
 * duplicates and malformed entries. Falls back to the bundled locales when
 * nothing usable is configured so the selector never becomes empty.
 */
export function canonicalizeAvailableLanguages(raw: unknown): string[] {
  if (!Array.isArray(raw)) return FE_SUPPORTED_LANGUAGE_OPTIONS;

  const languages: string[] = [];
  for (const entry of raw as LanguageEntry[]) {
    const candidate =
      typeof entry === "string" ? entry : entry?.code ?? entry?.language;
    const lng = canonicalizeLanguageTag(candidate);
    if (lng && !languages.includes(lng)) {
      languages.push(lng);
    }
  }
  return languages.length ? languages : FE_SUPPORTED_LANGUAGE_OPTIONS;
}
